module.exports = __webpack_public_path__ + "img/dist-default-image.a8aa6f02.png";